import React from 'react';
import './App.css';
import Router from './Router';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { StyledEngineProvider } from '@mui/material/styles';
import { PersistGate } from 'redux-persist/integration/react';

const App = () => {
  const version = {
    version: '1.1.4-beta',
    environment: process.env.REACT_APP_ENV,
  };

  console.log('ReactApp: ', version);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <StyledEngineProvider injectFirst>
          <Router />
        </StyledEngineProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
